import React from 'react';
import { FormattedMessage } from 'react-intl';
import OrderNumberLink from '../../../components/order-number-link';
import { Multiple } from '../../../components/multiple-text-blurb-for-grid';

export const OrderNumber = {
  getName: () => <FormattedMessage defaultMessage='Order #' description='customerOrdersGrid.columns.orderNumber' id='/mpH5j' />,
  id: 'orderNumber',

  render: (data) => {
    if (data.orderNumberCount > 1) {
      return <Multiple />;
    }

    return <OrderNumberLink id={data.id} orderNumber={data.orderNumber} salesOrderId={data.salesOrderId} selectGridWhenClicked />;
  },
};
